import { CandidateProfileTalentListTableColumns } from 'modules/candidate-profile/tables/types/CandidateProfileTalentListTable';
import { TableV3Filters } from 'common/table/components/TableV3';
import { SearchableCandidateProfileListFilterInput } from 'generated-graphql/types';
import { buildTextSearchClauses } from 'utils/buildTextSearchClauses';

// Lists matching the title or description searches.
export const getTalentListSearchClause = (
  searchFields: TableV3Filters<CandidateProfileTalentListTableColumns>['searchFields']
): SearchableCandidateProfileListFilterInput | undefined => {
  if (!searchFields) {
    return undefined;
  }

  const searchConditions: SearchableCandidateProfileListFilterInput[] = [];

  Object.entries(searchFields).forEach(([key, value]) => {
    if (!value) return;

    switch (key as keyof CandidateProfileTalentListTableColumns) {
      case 'title':
        searchConditions.push(...buildTextSearchClauses('title', value));
        break;
      case 'description':
        searchConditions.push(...buildTextSearchClauses('description', value));
        break;
      default:
        break;
    }
  });

  if (searchConditions.length === 0) {
    return undefined;
  }

  return { or: searchConditions };
};
